<template>
  <div class="submit-form">      
  <h2>Give Saludos</h2>
    <div v-if="!submitted">
      <div class="form-group">
        <label for="sender">Sender</label>
          <select 
            class="form-control" 
            name="sender" 
            id="sender" 
            v-model="message.sender">
              <option v-for="member in members" :key="member" v-bind:value="member.name">
                 {{ member.name }}
              </option>
          </select>
      </div>

      <div class="form-group">
        <label for="senderEmail">Sender Email</label>
        <input
          type="text"
          class="form-control"
          id="senderEmail"
          required
          v-model="message.senderEmail"
          name="senderEmail"
        />
      </div>

      <div class="form-group">
        <label for="receiver">Recipient</label>
          <select 
            class="form-control" 
            name="receiver" 
            id="sender" 
            v-model="message.receiver">
              <option v-for="member in members" :key="member" v-bind:value="member.name">
                 {{ member.name }}
              </option>
          </select>

      </div>

      <div class="form-group">
        <label for="receiverEmail">Recipient Email</label>
        <input
          type="text"
          class="form-control"
          id="receiverEmail"
          required
          v-model="message.receiverEmail"
          name="receiverEmail"
        />
      </div>

      <div class="form-group">
        <label for="message">Message</label>
        <textarea class="form-control"
            id="message"
            required
            v-model="message.message"
            name="message">
        </textarea>
      </div>

      <button @click="saveMessage" class="btn btn-success">Submit</button>
    </div>

    <div v-else>
      <h4>You submitted successfully!</h4>
      <button class="btn btn-success" @click="newMessage">Give more saludos</button>
    </div>
  </div>
</template>

<script>
import MessageDataService from "../services/MessageDataService";

export default {
  name: "add-message",
  data() {
    return {
      members: [
        {value: 'Eugenia Tenorio',name:'Eugene'},
        {value: 'Doris Pagtananan',name: 'Doris'},
        {value: 'Jack Lagare',name: 'Jack'}
      ],
      message: {
        id: null,
        sender: "",
        message: "",
        receiver: ""
      },
      submitted: false
    };
  },
  methods: {
    saveMessage() {
      var data = {
        senderName: this.message.sender,
        senderEmail: this.message.senderEmail,
        receiverName: this.message.receiver,
        receiverEmail: this.message.receiverEmail,
        saludosMessage: this.message.message
      };

      MessageDataService.create(data)
        .then(response => {
          this.message.id = response.data.id;
          console.log(response.data);
          this.submitted = true;
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    newMessage() {
      this.submitted = false;
      this.message = {};
    }
  }
};
</script>

<style>
.submit-form {
  max-width: 300px;
  margin: auto;
}
</style>
